import React, { FunctionComponent } from "react";
import styles from "./styles.module.scss";
import { Grid, ListItem, Stack } from "@mui/material";
import { strings } from "../../../localization/LocalizedStrings";
import { CustomLoadingIndicator } from "../../CustomLoadingIndicator";
import { ContainedButton } from "../../ContainedButton";

export const BooleanAttributesListItem: FunctionComponent<IBooleanAttributesListItemProps> = ({
  isPublic,
  className,
  titleWeight,
  hideIsGatefold,
  hideIsClean,
  isCleanLoading,
  isGatefoldLoading,
  hasLyricsLoading,
  hasInsertLoading,
  isGatefold,
  hasInsert,
  hasLyrics,
  isClean,
  onIsGatefoldChanged,
  onHasInsertChanged,
  onHasLyricsChanged,
  onIsCleanChanged
}) => {
  const toggleIsClean = () => {
    if (isCleanLoading || isPublic) return;
    onIsCleanChanged(!isClean);
  };
  const toggleIsGatefold = () => {
    if (isGatefoldLoading || isPublic) return;
    onIsGatefoldChanged(!isGatefold);
  };
  const toggleHasInsert = () => {
    if (hasInsertLoading || isPublic) return;
    onHasInsertChanged(!hasInsert);
  };
  const toggleHasLyrics = () => {
    if (hasLyricsLoading || isPublic) return;
    onHasLyricsChanged(!hasLyrics);
  };
  return (
    <ListItem className={className}>
      <div className={styles.itemDiv}>
        <Grid container flexGrow={1} spacing={2}>
          {!hideIsClean && (
            <Grid item xs>
              <Stack spacing={1} alignItems={"center"}>
                <p className={styles.title} style={{ fontWeight: titleWeight }}>
                  {strings.filter_clean_title}
                </p>
                <ContainedButton style={{ height: "32px" }} onClick={toggleIsClean}>
                  {isCleanLoading ? (
                    <CustomLoadingIndicator className={styles.loadingIndicator} />
                  ) : isClean ? (
                    strings.stats_pie_yes
                  ) : (
                    strings.stats_pie_no
                  )}
                </ContainedButton>
              </Stack>
            </Grid>
          )}
          <Grid item xs>
            <Stack spacing={1} alignItems={"center"}>
              <p className={styles.title} style={{ fontWeight: titleWeight }}>
                {strings.filter_insert_title}
              </p>
              <ContainedButton style={{ height: "32px" }} onClick={toggleHasInsert}>
                {hasInsertLoading ? (
                  <CustomLoadingIndicator className={styles.loadingIndicator} />
                ) : hasInsert ? (
                  strings.stats_pie_yes
                ) : (
                  strings.stats_pie_no
                )}
              </ContainedButton>
            </Stack>
          </Grid>
          <Grid item xs>
            <Stack spacing={1} alignItems={"center"}>
              <p className={styles.title} style={{ fontWeight: titleWeight }}>
                {strings.filter_lyrics_title}
              </p>
              <ContainedButton style={{ height: "32px" }} onClick={toggleHasLyrics}>
                {hasLyricsLoading ? (
                  <CustomLoadingIndicator className={styles.loadingIndicator} />
                ) : hasLyrics ? (
                  strings.stats_pie_yes
                ) : (
                  strings.stats_pie_no
                )}
              </ContainedButton>
            </Stack>
          </Grid>
          {!hideIsGatefold && (
            <Grid item xs>
              <Stack spacing={1} alignItems={"center"}>
                <p className={styles.title} style={{ fontWeight: titleWeight }}>
                  {strings.filter_gatefold_title}
                </p>
                <ContainedButton style={{ height: "32px" }} onClick={toggleIsGatefold}>
                  {isGatefoldLoading ? (
                    <CustomLoadingIndicator className={styles.loadingIndicator} />
                  ) : isGatefold ? (
                    strings.stats_pie_yes
                  ) : (
                    strings.stats_pie_no
                  )}
                </ContainedButton>
              </Stack>
            </Grid>
          )}
        </Grid>
      </div>
    </ListItem>
  );
};

export interface IBooleanAttributesListItemProps {
  isPublic: boolean;
  className?: string;
  titleWeight: string;
  hideIsGatefold: boolean;
  hideIsClean: boolean;
  isCleanLoading: boolean;
  isGatefoldLoading: boolean;
  hasLyricsLoading: boolean;
  hasInsertLoading: boolean;
  isGatefold: boolean;
  hasInsert: boolean;
  hasLyrics: boolean;
  isClean: boolean;
  onIsGatefoldChanged: (newValue: boolean) => void;
  onHasInsertChanged: (newValue: boolean) => void;
  onHasLyricsChanged: (newValue: boolean) => void;
  onIsCleanChanged: (newValue: boolean) => void;
}
